 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLDEDICATION from '@/components/xhtml/dedication'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLMAP from '@/components/xhtml/map'
 import XHTMLILLUSTRATIONS from '@/components/xhtml/illustrations'
 import XHTMLACKNOWLEDGMENTS from '@/components/xhtml/acknowledgments'
 import XHTMLAUTHOR from '@/components/xhtml/author'
 import XHTMLFRONTISPIECE from '@/components/xhtml/frontispiece'
 import XHTMLINTRODUCTION from '@/components/xhtml/introduction'
 import XHTMLCHAPTER1 from '@/components/xhtml/chapter1'
 import XHTMLCHAPTER2 from '@/components/xhtml/chapter2'
 import XHTMLCHAPTER3 from '@/components/xhtml/chapter3'
 import XHTMLCHAPTER4 from '@/components/xhtml/chapter4'
 import XHTMLCHAPTER5 from '@/components/xhtml/chapter5'
 import XHTMLCHAPTER6 from '@/components/xhtml/chapter6'
 import XHTMLCHAPTER7 from '@/components/xhtml/chapter7'
 import XHTMLCHAPTER8 from '@/components/xhtml/chapter8'
 import XHTMLCHAPTER9 from '@/components/xhtml/chapter9'
 import XHTMLCHAPTER10 from '@/components/xhtml/chapter10'
 import XHTMLCHAPTER11 from '@/components/xhtml/chapter11'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLORDER from '@/components/xhtml/order'
 import XHTMLNOTES from '@/components/xhtml/notes'
 import XHTMLBIBLIOGRAPHY from '@/components/xhtml/bibliography'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLADCARD from '@/components/xhtml/adcard'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/map",
 			"name" : "xhtml/map",
 			"component" : XHTMLMAP
 		},
 		{
 			"path" : "/xhtml/illustrations",
 			"name" : "xhtml/illustrations",
 			"component" : XHTMLILLUSTRATIONS
 		},
 		{
 			"path" : "/xhtml/acknowledgments",
 			"name" : "xhtml/acknowledgments",
 			"component" : XHTMLACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/author",
 			"name" : "xhtml/author",
 			"component" : XHTMLAUTHOR
 		},
 		{
 			"path" : "/xhtml/frontispiece",
 			"name" : "xhtml/frontispiece",
 			"component" : XHTMLFRONTISPIECE
 		},
 		{
 			"path" : "/xhtml/introduction",
 			"name" : "xhtml/introduction",
 			"component" : XHTMLINTRODUCTION
 		},
 		{
 			"path" : "/xhtml/chapter1",
 			"name" : "xhtml/chapter1",
 			"component" : XHTMLCHAPTER1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js